// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState, useRef, useEffect} from 'react';
import {Settings_context} from '../../settings_ctx';
import cn from 'classnames';
import './tab_buttons.less';
import {noop} from 'zutil';

interface i_tab_item {
    id: string;
    title: JSX.Element | string;
    hide?: boolean;
    disabled?: boolean;
}

interface i_tab_buttons_props {
    items: i_tab_item[],
    class_name?: string;
    active: string;
    on_change: (val:string)=>void;
    sliding?: boolean;
}
export const Tab_buttons = (p:i_tab_buttons_props)=>{
    const {items, class_name, active, on_change, sliding} = p;
    const {theme_name} = useContext(Settings_context);
    const is_hola2023 = !['default', 'purple', 'oculus',
        'browserai'].includes(theme_name);
    const cls = cn(class_name, 'hola_tab_buttons', {sliding},
        is_hola2023 && `hola_tab_buttons--hola2023`,
        theme_name == 'oculus' && 'hola_tab_buttons--oculus',
        theme_name == 'browserai' && 'hola_tab_buttons--browserai'
    );
    const [slider_style, set_slider_style] = useState({});
    const [visible_items, set_visible_items] = useState(0);
    const tabs_ref = useRef();
    const items_ref = {};
    const on_slide = el=>{
        const el_bound = el.getBoundingClientRect();
        // @ts-ignore
        const tabs_bound = tabs_ref.current.getBoundingClientRect();
        const style = {
            left: el_bound.left - tabs_bound.left,
            width: el_bound.width,
            height: el_bound.height,
        };
        set_slider_style(style);
    };
    useEffect(()=>{
        if (sliding && items_ref[active])
        {
            on_slide(items_ref[active].current);
            setTimeout(()=>on_slide(items_ref[active].current), 500);
        }
        const update_slider = ()=>{
            if (!items_ref[active])
                return;
            on_slide(items_ref[active].current);
        };
        window.addEventListener('resize', update_slider);
        return ()=>{ window.removeEventListener('resize', update_slider); };
    }, [active, visible_items]);
    const _visible_items = items.reduce((a, b)=>a+(+!b.hide), 0);
    if (visible_items!=_visible_items)
        set_visible_items(_visible_items);
    return <div className={cls} ref={tabs_ref}>
      {items.map(item=>{
          const item_ref = items_ref[item.id] = useRef();
          const item_cls = cn('hola_tab_buttons__item', active==item.id
              && 'hola_tab_buttons__item--active',
              item.disabled && 'hola_tab_buttons__item--disabled');
          const on_item_click = ()=>on_change(item.id);
          if (item.hide)
              return null;
          return <button className={item_cls} key={item.id}
            onClick={item.disabled ? noop : on_item_click}
            type="button" ref={item_ref}>
              {item.title}
              {item.disabled ? <span>coming soon</span> : null}
            </button>;
      })}
      {sliding && <div className="hola_tab_buttons__slider"
        style={slider_style}/>}
    </div>;
};
